
<video :title="title" :aria-label="title" class="bg-video" autoplay loop muted preload @canplay="canPlay = true" :class="canPlay ? 'can-play' : '' ">
  <source :src="url" type="video/mp4"  />
</video>
